import { Box, RadioGroup, TextField } from '@mui/material';
import { REASON_COMMENT_MAX_LENGTH, REASON_STEP } from '../content';
import { EXIT_REASONS, ExitReason, exitReasonOption } from '../reasons';
import ChoiceRow from './ChoiceRow';
import { REASON_ICONS } from './reasonIcons';

type Props = {
  value?: ExitReason;
  onChange: (reason: ExitReason) => void;
  comment: string;
  onCommentChange: (comment: string) => void;
};

// The two questions of the PostHog cancellation survey: the reason, then a note where the reason asks for one.
export default function CancellationReasonStep({ value, onChange, comment, onCommentChange }: Props) {
  const selected = exitReasonOption(value);
  return (
    <Box>
      <RadioGroup
        aria-label={REASON_STEP.legend}
        value={value || ''}
        onChange={(event) => onChange(event.target.value as ExitReason)}
        sx={{ gap: 1 }}
      >
        {EXIT_REASONS.map((option, index) => (
          <ChoiceRow
            key={option.id}
            value={option.id}
            icon={REASON_ICONS[option.id]}
            label={option.label}
            checked={value === option.id}
            index={index}
          />
        ))}
      </RadioGroup>

      {/* Never required: a cancellation must not depend on someone being willing to type. */}
      {selected?.prompt && (
        <TextField
          value={comment}
          onChange={(event) => onCommentChange(event.target.value.slice(0, REASON_COMMENT_MAX_LENGTH))}
          label={selected.prompt}
          placeholder={selected.promptHint}
          helperText={REASON_STEP.commentHelper}
          multiline
          minRows={2}
          fullWidth
          InputLabelProps={{ shrink: true }}
          inputProps={{ maxLength: REASON_COMMENT_MAX_LENGTH }}
          sx={{ mt: 2.5 }}
        />
      )}
    </Box>
  );
}
